import React from "react";
import { AiFillHtml5, AiFillGithub } from "react-icons/ai";
import {
  FaCss3Alt,
  FaReact,
  FaSass,
  FaBootstrap,
  FaWordpress,
  FaNodeJs,
  FaNode,
} from "react-icons/fa";
import { BiLogoJavascript } from "react-icons/bi";
import {
  SiFirebase,
  SiRedux,
  SiTailwindcss,
  SiGreensock,
  SiJquery,
  SiPwa,
  SiExpress,
  SiMongodb,
  SiMui,
} from "react-icons/si";
import { BsGit } from "react-icons/bs";
import { TbBrandNextjs, TbBrandReactNative } from "react-icons/tb";
import { SiPrisma } from "react-icons/si";

const data = [
  {
    icon: <AiFillHtml5 fontSize={70} color="#fff" />,
    name: "HTML",
  },
  {
    icon: <FaCss3Alt fontSize={70} color="#fff" />,
    name: "CSS",
  },
  {
    icon: <BiLogoJavascript fontSize={70} color="#fff" />,
    name: "JAVASCRIPT",
  },
  {
    icon: <SiFirebase fontSize={70} color="#fff" />,
    name: "FIREBASE",
  },
  {
    icon: <BsGit fontSize={70} color="#fff" />,
    name: "GIT",
  },
  {
    icon: <AiFillGithub fontSize={70} color="#fff" />,
    name: "GITHUB",
  },
  {
    icon: <FaReact fontSize={70} color="#fff" />,
    name: "REACT",
  },
  {
    icon: <SiRedux fontSize={70} color="#fff" />,
    name: "REDUX",
  },
  {
    icon: <SiMui fontSize={70} color="#fff" />,
    name: "MATERIAL UI",
  },
  {
    icon: <FaBootstrap fontSize={70} color="#fff" />,
    name: "FIREBASE",
  },
  {
    icon: <FaNode fontSize={70} color="#fff" />,
    name: "NODE JS",
  },
  {
    icon: <SiExpress fontSize={70} color="#fff" />,
    name: "EXPRESS JS",
  },
  {
    icon: <SiMongodb fontSize={70} color="#fff" />,
    name: "MONGO DB",
  },
  {
    icon: <TbBrandReactNative fontSize={70} color="#fff" />,
    name: "REACT NATIVE",
  },
];
function Techstack() {
  return (
    <div
      className="relative w-11/12 lg:w-4/5 mx-auto flex items-center justify-center gap-3 flex-wrap my-5 lg:my-10
       bg-gradient-to-r from-slate-900 via-purple-600 to-slate-900 "
    >
      {/* <img
        src="./star.jpg"
        alt=""
        className="h-full w-full object-cover opacity-10 absolute bottom-0"
      /> */}
      {data.map((item, i) => (
        <div
          className="w-36 md:w-60 h-36 flex items-center justify-center m-3 border border-[#df8de2] bg-black/30  z-20 rounded-sm hover:border-[#ad50eb] hover:scale-[1.02] transition-all duration-300"
          key={i}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div>{item.icon}</div>
            <div style={{ color: "white" }}>{item.name}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Techstack;
